import {atom} from "jotai";
import {
  atomWithStorage,
  createJSONStorage
} from "jotai/utils";

export const userInfo = {
  email: '',
  name: '',
  id: ''
};

export const loginParams = {
  username: '',
  password: ''
};

export const adminInfo = {
  email: '',
  name: '',
  convertedUser: localStorage.getItem('mediaUsername') ?? '',
  id: '',
  accountProfile: ''
};

export const selectedAdverIdsAtom = atom(new Set());
export const overviewCacheAtom = atom(null);

const initialTokenResult = {
  accessToken: '',
  refreshToken: '',
  id: '',
  role: '',
  name: '',
  serverName: ''
};

const sessionStorageConfig = createJSONStorage(
    () => window.sessionStorage
);

export const tokenResultAtom = atomWithStorage(
    'adminTokenResult',
    initialTokenResult,
    sessionStorageConfig,
    {
      getOnInit: true
    }
);

export const reportsInfoAtom = atom({
  id: null,
  groupBy: null
});

export const findIdParams = {
  email: '',
  phone: ''
};

export const findIdResult = [];

export const findPasswordParams = {
  phone: '',
  email: '',
  username: ''
};